module.exports = require("moment");


/*****************
 ** WEBPACK FOOTER
 ** external "moment"
 ** module id = 8
 ** module chunks = 0
 **/